// -----------------------------------------------------------------------------
export enum NoRecommendationsReasons {
  FailedToQueryServer = 'FailedToQueryServer',
  NoGameConfig = 'NoGameConfig',
  CooldownCrashed = 'CooldownCrashed',
  CooldownInitial = 'CooldownInitial',
  CooldownDisplay = 'CooldownDisplay',
  CooldownOWLaunch = 'CooldownOWLaunch',
  UserPersistentPhasing = 'UserPersistentPhasing',
  NoRelevantApp = 'NoRelevantApp',
  PortfolioExhausted = 'PortfolioExhausted',
  FailedToGetServiceConfig = 'FailedToGetServiceConfig',
  SpecificApplicationAlreadyDownloaded = 'SpecificApplicationAlreadyDownloaded',
  CapLimitReached = 'CapLimitReached',
  DedicatedAppAlreadyInstalled = 'DedicatedAppAlreadyInstalled',
  AppAlreadyInstalled = 'AppAlreadyInstalled',
  ErrorNoAppContext = 'ErrorNoAppContext',
  GPUNotSupported = 'GPUNotSupported',
  DismissedByUser = 'DismissedByUser',
  BlackListedApp = 'BlackListedApp',
  NoAppToRecommend = 'NoAppToRecommend',
  GameIsRunning = 'GameIsRunning',
  MinimumGameSessionLengthNotReached = 'MinimumGameSessionLengthNotReached',
  GameExcludedByUser = 'GameExcludedByUser',
  AppExcludedByUser = 'AppExcludedByUser',
  GeoRestricted = 'GeoRestricted',
  OWInstalled = 'OWInstalled',
  DevAbort = 'DevAbort',
  NotificationsDisabled = 'NotificationsDisabled',
  ConfiguredForStart = 'ConfiguredForStart',
  ConfiguredForEnd = 'ConfiguredForEnd',
  PlatformDisabled = 'PlatformDisabled',
  HostAppNotApproved = 'HostAppNotApproved',
  ExtensionPhasing = 'extensionPhasing',
  GameEventsNotSupported = 'GameEventsNotSupported',
  GameEventsNotTriggered = 'GameEventsNotTriggered',
  GameEventWrongValue = 'GameEventWrongValue',
  GameEventsTimeout = 'GameEventsTimeout',
  OverlayNotSupported = 'OverlayNotSupported',
  GameEventsPlatformNotSupported = 'GameEventsPlatformNotSupported',
  GameEventsNotSupportedOnGameStart = 'GameEventsNotSupportedOnGameStart',
}
